/**
 * System API - Wrapper for system functionality
 */

import { nativeBridge } from "../index"
import type { SystemInfo, SystemPermissions, SystemForegroundEvent, SystemBackgroundEvent } from "../types"

export class SystemAPI {
  /**
   * Get system information
   */
  async getInfo(): Promise<SystemInfo> {
    return nativeBridge.request<void, SystemInfo>("system.getInfo")
  }

  /**
   * Check permissions
   */
  async checkPermissions(): Promise<SystemPermissions> {
    return nativeBridge.request<void, SystemPermissions>("system.checkPermissions")
  }

  /**
   * Subscribe to foreground events
   */
  async onForeground(callback: (event: SystemForegroundEvent) => void): Promise<() => Promise<void>> {
    const subscriptionId = await nativeBridge.subscribe<SystemForegroundEvent>("system.foreground", callback)

    return async () => {
      await nativeBridge.unsubscribe(subscriptionId)
    }
  }

  /**
   * Subscribe to background events
   */
  async onBackground(callback: (event: SystemBackgroundEvent) => void): Promise<() => Promise<void>> {
    const subscriptionId = await nativeBridge.subscribe<SystemBackgroundEvent>("system.background", callback)

    return async () => {
      await nativeBridge.unsubscribe(subscriptionId)
    }
  }
}

// Export singleton instance
export const systemAPI = new SystemAPI()
